<template xmlns:v-slot="http://www.w3.org/1999/html">
  <div class="kt-portlet kt-portlet--height-fluid mt-3">
    <div
      class="kt-portlet__head kt-portlet__head kt-portlet__head--lg kt-portlet__head--noborder kt-portlet__head--break-sm flex-wrap"
    >
      <div class="kt-portlet__head-label mb-2">
        <span class="kt-portlet__head-icon">
          <i class="fal fa-bullseye-arrow" />
        </span>
        <h3 class="kt-portlet__head-title">Goal Management</h3>
      </div>
      <div class="kt-portlet__head-toolbar">
        <div class="kt-portlet__head-group">
          <v-dialog
            v-model="assignGoalsToUserDialog"
            max-width="800px"
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn color="blue darken-3" dark class="mb-2" v-on="on" text>
                <i class="fal fa-plus mr-2"></i>
                Assign Goal
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">
                  <v-icon class="mr-1">fal fa-users-class</v-icon>Assign Goal to
                  Other Users
                </span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4" v-if="hideAssignToAll">
                      <v-checkbox
                        v-model="assignToAll"
                        label="Assign to All"
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="12" sm="6" md="8">
                      <multiselect
                        v-model="selectedUsers"
                        name="users"
                        :options="assignUsersSelection"
                        @search-change="fetchUsers"
                        :hide-selected="true"
                        label="name"
                        placeholder="Find users..."
                        multiple
                        clearable
                        @change="selectedUsersChanged"
                        :disabled="assignToAll"
                        v-validate="userValidate"
                      >
                        <template>
                          <span slot="noResult"
                            >No users found. Try changing the name.</span
                          >
                          <span slot="noOptions">Please input a name.</span>
                        </template>
                      </multiselect>
                      <span
                        class="kt-font-danger validate-error"
                        v-show="errors.has('users')"
                        autocomplete="off"
                      >
                        {{ errors.first('users') }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                        v-model="new_goal"
                        solo
                        name="new_goal"
                        label="Goal"
                        v-validate="newGoalValidate"
                      ></v-textarea>
                      <span
                        class="kt-font-danger validate-error"
                        v-show="errors.has('new_goal')"
                        autocomplete="off"
                      >
                        {{ errors.first('new_goal') }}
                      </span>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" :loading="isLoading" text @click="assign"
                  >Assign</v-btn
                >
                <v-btn color="blue-grey" text @click="close">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </div>
    </div>
    <div class="kt-portlet__body">
      <v-data-table
        :headers="headers"
        :items="existing_goals"
        :search="pagination.search"
        :sort-by="pagination.sortBy"
        :sort-desc="pagination.sortDesc"
        class="elevation-1"
        :items-per-page="pagination.per_page"
        :server-items-length="pagination.total"
        @update:page="changePage"
        :loading="isFetching"
        :options.sync="options"
      >
        <template v-slot:item.is_sent="{ item }">
          <span>{{ item.is_sent ? 'Sent' : 'Pending' }}</span>
        </template>
        <template v-slot:item.created_at="{ item }">
          <span>{{ item.created_at | displayDateTime }}</span>
        </template>
      </v-data-table>
    </div>
  </div>
</template>
<script>
import VueContentLoader from 'vue-content-loading';
import {
  includes as _includes,
  forEach as _forEach,
  merge as _merge,
  union as _union, some as _some, isEmpty as _isEmpty,
} from 'lodash-es'
export default {
  name: 'GoalOverview',
  components: {
    VueContentLoader,
  },
  data: () => ({
    headers: [
      {
        text: 'Salesperson',
        align: 'left',
        sortable: true,
        value: 'user.name',
      },
      {
        text: 'Goal',
        align: 'left',
        sortable: false,
        value: 'goal',
      },
      {
        text: 'Status',
        align: 'left',
        sortable: true,
        value: 'is_sent',
      },
      {
        text: 'Date Created',
        value: 'created_at',
        align: 'center',
        sortable: false,
        width: 200,
      },
    ],
    options: {},
    users: [],
    pagination: {
      total: 1,
      per_page: 5,
      current_page: 1,
      search: '',
      sortBy: 'is_sent',
      sortDesc: false,
    },
    isFetching: false,
    goalHistoryDialog: false,
    existing_goals: [],
    selectedUser: null,
    new_goal: '',
    assignGoalsToUserDialog: false,
    selectedUsers: [],
    assignToAll: false,
    usersSearchResult: [],
    isLoading: false,
  }),

  watch: {
    options: {
      handler() {
        this.getGoals();
      },
      deep: true,
    },
  },

  computed: {
    assignUsersSelection() {
      return _union(this.selectedUsers, this.usersSearchResult);
    },
    userValidate() {
      return this.assignToAll ? '' : 'required';
    },
    newGoalValidate() {
      return 'required';
    },
    hideAssignToAll() {
      const { roles } = this.$auth.user();
      return !(_some(roles, { name: 'salesperson' })
          || _some(roles, { name: 'advisor' })
          || _isEmpty(this.$auth.user().specific_dealer_id));
    },
  },

  created() {
    this.getGoals();
  },

  methods: {
    getGoals() {
      this.pagination.sortBy =
        this.options.sortBy !== undefined
          ? this.options.sortBy[0]
          : this.pagination.sortBy;
      this.pagination.sortDesc =
        this.options.sortDesc !== undefined
          ? this.options.sortDesc[0]
          : this.pagination.sortDesc;
      this.isFetching = true;
      this.$http
        .get(`/user-goal`, {
          params: this.pagination,
        })
        .then(({ data }) => {
          this.pagination.total = data.total;
          this.pagination.current_page = data.current_page;
          this.pagination.per_page = Number(data.per_page);
          this.existing_goals = data.data;
          this.isFetching = false;
        })
        .catch((error) => {});
    },
    fetchUsers(filter) {
      const params = {};
      if (filter) {
        params.filter = filter;
      }

      this.$http
        .get('/playlist/assign', { params })
        .then(({ data }) => {
          this.usersSearchResult = data;
        })
        .catch(() => {});
    },
    changePage(page) {
      this.pagination.current_page = page;
      this.getGoals();
    },
    close() {
      this.assignGoalsToUserDialog = false;
      this.new_goal = '';
    },
    assign() {
      if (this.assignToAll) {
        this.assignGoalToAllUsers();
      } else {
        this.assignToMultipleUsers();
      }
    },
    assignGoalToAllUsers() {
      this.$validator.validate('*').then((result) => {
        if (result) {
          this.$http
            .post('/user-goal/assign-to-all', {
              new_goal: this.new_goal,
            })
            .then((response) => {
              this.assignGoalsToUserDialog = false;
              this.$notify('success', 'Goals assigned successfully.');
              setTimeout(function () {
                this.new_goal = '';
                location.reload();
              }, 1000);
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    },
    assignToMultipleUsers() {
      this.$validator.validate('*').then((result) => {
        if (result) {
          var ids = this.selectedUsers.map(function (value, index, array) {
            return value.id;
          });
          this.$http
            .post('/user-goal/assign-to-multiple-users', {
              new_goal: this.new_goal,
              ids: ids,
            })
            .then((response) => {
              this.$notify('success', 'Goals assigned successfully.');
              setTimeout(function () {
                this.new_goal = '';
                location.reload();
              }, 1000);
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    },
    selectedUsersChanged() {
      this.searchUsers = '';
    },
  },
};
</script>
